import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import InputNumber from '../form/InputNumber'
import { isEmpty } from '../../utils/validations'

const LabelInputValid = (
  props,
  error,
  glyph,
  glyphClickable,
  hint,
  validate,
  defaultActive,
  children,
  select,
  onMouseDown,
  onMouseUp,
  onClick,
  className,
  checkbox,
  radio,
  disabledHelper,
  ignoreActiveClass
) => {
  const {
    id,
    name,
    labelLeft,
    onChange,
    labelRight,
    inputClassName,
    typeMask,
    placeholder,
    type = 'text',
    checked,
  } = props

  const fieldClass = classNames(
    'field',
    {
      'addon-right': glyph,
      active:
        !ignoreActiveClass &&
        (!isEmpty(props.name.input.value) || defaultActive),
      valid:
        validate &&
        props.name.input.value &&
        (Array.isArray(props.name.input.value)
          ? props.name.input.value.length
          : true) &&
        !error,
      invalid: validate && error,
      [className]: className,
    },
    className,
    { 'field-select': select },
    { 'field-checkbox': checkbox },
    { 'field-radio': radio }
  )

  const fieldSelect = classNames('field-select')

  return (
    <>
      {type === 'text' && (
        <div
          className={
            type === 'text'
              ? 'label-input margin-bottom'
              : 'field no-padding margin-bottom no-padding margin-bottom'
          }
        >
          <label className='flex'>
            {labelLeft && <span className='margin-right'>{labelLeft}</span>}
            <div className='field no-margin no-margin'>
              <div className='dashed-border'>
                {type === 'text' && (
                  <InputNumber
                    {...name.input}
                    id={id}
                    className='size-input input-par'
                    separator=''
                    delimiter=''
                    placeholder={placeholder}
                    typeMask={typeMask}
                  />
                )}
              </div>
            </div>
            {labelRight && <span>{labelRight}</span>}
          </label>
          {{ ...(name.error !== '') } && (
            <span className='helper'>{props.name.error}</span>
          )}
        </div>
      )}

      {type === 'checkbox' && (
        <div
          className={
            select
              ? `${fieldClass} ${fieldSelect}`
              : `${fieldClass} no-padding margin-bottom no-padding margin-bottom`
          }
        >
          <div className={inputClassName}>
            <input
              {...name.input}
              type={type}
              id={id}
              onChange={onChange}
              className={!className ? '' : className}
              checked={checked}
            />
            <label htmlFor={id} className='label'>
              {labelLeft}
            </label>
          </div>
        </div>
      )}
    </>
  )
}

LabelInputValid.propTypes = {
  id: PropTypes.string,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  labelLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  labelRight: PropTypes.string,
  inputClassName: PropTypes.string,
  value: PropTypes.string,
  typeMask: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
}

export default LabelInputValid
